<template>
  <div
    v-if="checker.localWork.value"
    class="overflow-y-auto"
    :class="
      variant === 'modal'
        ? 'mt-3.5 px-6'
        : 'min-h-0 flex-1 px-4 pt-2.5 pb-[calc(env(safe-area-inset-bottom)+26px)]'
    "
  >
    <InfringingWorkDetails
      :variant="variant"
      :details="checker.details.value"
      :local="checker.localWork.value"
      @view-registration="checker.openFile"
    />
  </div>
</template>

<script setup lang="ts">
import InfringingWorkDetails from '../match/InfringingWorkDetails.vue'
import { useChecker } from './useChecker'

defineProps<{ variant: 'modal' | 'sheet' }>()

const checker = useChecker()
</script>
